<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-row class="fill-height" no-gutters>
          <v-col class="col-12">
            <v-row>
              <v-col class="col-12">
                <v-card-title>
                  <v-row>
                    <v-col class="col-12 col-md-4">
                      <h1 class="primary-color">Competencies</h1>
                    </v-col>
                    <v-spacer />
                    <v-col class="col-12 col-md-2">
                      <v-btn class="new-item-btn float-right" block @click="openCreateCompetence">
                        <v-icon size="20">mdi-plus</v-icon>
                        &nbsp;&nbsp;Create competence
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>

                <v-alert
                  v-if="messageCreateCompetence"
                  outlined
                  :color="successfullCreateCompetence ? 'success' : 'error'"
                  :icon="successfullCreateCompetence ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageCreateCompetence }}
                </v-alert>
                <v-alert
                  v-if="messageDeleteCompetence"
                  outlined
                  :color="successfullDeleteCompetence ? 'success' : 'error'"
                  :icon="successfullDeleteCompetence ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageDeleteCompetence }}
                </v-alert>
                <v-alert
                  v-if="messageEditCompetence"
                  outlined
                  :color="successfullEditCompetence ? 'success' : 'error'"
                  :icon="successfullEditCompetence ? 'mdi-check-circle' : 'mdi-alert'"
                  dismissible
                >
                  {{ messageEditCompetence }}
                </v-alert>

                <v-data-table
                  :headers="headers"
                  :items="competencies"
                  item-key="id"
                  :loading="loading"
                  loading-text="Loading... Please, wait"
                  :server-items-length="pagination.totalItems"
                  :items-per-page="pagination.itemsPerPage"
                  :page.sync="pagination.page"
                  item-class="text-wrap"
                  @update:page="handlePageChange"
                >
                  <template #[`item.hasTraining`]="{ item }">
                    <v-card-text v-if="item.hasTraining" class="d-flex align-end"
                      ><v-icon size="20" color="green">mdi-check</v-icon></v-card-text
                    >
                    <v-card-text v-else class="d-flex align-end"
                      ><v-icon size="20" color="red">mdi-close</v-icon></v-card-text
                    >
                  </template>
                  <template #[`item.createdAt`]="{ item }">
                    {{ item.createdAt | formatDate }}
                  </template>
                  <template #[`item.actions`]="{ item }">
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openShowDetails(item)">
                          <v-icon size="20" color="primary">mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>Show details</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openEditCompetence(item)">
                          <v-icon size="20" color="primary">mdi-square-edit-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit competence</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn icon v-on="on" @click="openDeleteCompetence(item)">
                          <v-icon size="20" color="error">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete competence</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-alert
              v-if="messageCompetencies"
              class="mt-4"
              outlined
              :color="successfullCompetencies ? 'success' : 'error'"
              :icon="successfullCompetencies ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageCompetencies }}
            </v-alert>

            <v-alert
              v-if="messageInfo"
              class="mt-4"
              outlined
              :color="successfullInfo ? 'success' : 'error'"
              :icon="successfullInfo ? 'mdi-check-circle' : 'mdi-alert'"
              dismissible
            >
              {{ messageInfo }}
            </v-alert>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>

    <v-dialog v-model="createCompetenceDialog" max-width="600" persistent>
      <v-card>
        <v-form ref="createCompetenceForm" @submit.prevent="createCompetence">
          <v-card-title class="px-6">
            <h5 class="primary-color">Create Competence</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="competence.name"
                    class="py-0 mb-6 no-border-radius"
                    label="Name *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-text-field
                    v-model="competence.legacyName"
                    class="py-0 mb-6 no-border-radius"
                    label="Legacy name *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-textarea
                    v-model="competence.description"
                    class="py-0 mb-6 no-border-radius"
                    label="Description *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-switch
                    v-model="competence.hasTraining"
                    class="py-0 mb-6 no-border-radius"
                    flat
                    label="Has training"
                  />
                </v-col>
                <v-col cols="6" class="pb-0">
                  <v-text-field
                    v-model="competence.extraWeight"
                    class="py-0 mb-6 no-border-radius"
                    label="Extra weight *"
                    type="number"
                    :min="0"
                    :step="1"
                    :rules="rulesNumber"
                    dense
                  />
                </v-col>
                <v-col cols="6" class="pb-0">
                  <v-select
                    v-model="competence.type"
                    class="py-0 mb-6 no-border-radius"
                    label="Type"
                    :items="info.type"
                  />
                </v-col>
                <v-col cols="6" class="pb-0">
                  <v-select
                    v-model="competence.category"
                    class="py-0 mb-6 no-border-radius"
                    label="Category"
                    :items="info.category"
                  />
                </v-col>
              </v-row>
              <v-alert
                v-if="messageCreateCompetenceInside"
                class="mb-0 mt-3"
                outlined
                :color="successfullCreateCompetenceInside ? 'success' : 'error'"
                :icon="successfullCreateCompetenceInside ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageCreateCompetenceInside }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="cancelCreateCompetence"> Cancel </v-btn>
            <v-btn v-if="!creatingCompetence" type="submit" class="ok-modal"> Create </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editCompetenceDialog" max-width="600" persistent>
      <v-card>
        <v-form ref="editCompetenceForm" @submit.prevent="editCompetence">
          <v-card-title class="px-6">
            <h5 class="primary-color">Update Competence</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    v-model="itemToEdit.name"
                    class="py-0 mb-6 no-border-radius"
                    label="Name *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-text-field
                    v-model="itemToEdit.legacyName"
                    class="py-0 mb-6 no-border-radius"
                    label="Legacy name *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-textarea
                    v-model="itemToEdit.description"
                    class="py-0 mb-6 no-border-radius"
                    label="Description *"
                    :rules="rules"
                    dense
                  />
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-switch
                    v-model="itemToEdit.hasTraining"
                    class="py-0 mb-6 no-border-radius"
                    flat
                    label="Has training"
                  />
                </v-col>
                <v-col cols="6" class="pb-0">
                  <v-text-field
                    v-model="itemToEdit.extraWeight"
                    class="py-0 mb-6 no-border-radius"
                    label="Extra weight *"
                    type="number"
                    :min="0"
                    :step="1"
                    :rules="rulesNumber"
                    dense
                  />
                </v-col>
                <v-col cols="6" class="pb-0">
                  <v-select v-model="itemToEdit.type" label="Type" :items="info.type" />
                </v-col>
                <v-col cols="6" class="pb-0">
                  <v-select v-model="itemToEdit.category" label="Category" :items="info.category" />
                </v-col>
              </v-row>
              <v-alert
                v-if="messageEditCompetenceInside"
                class="mb-0 mt-3"
                outlined
                :color="successfullEditCompetenceInside ? 'success' : 'error'"
                :icon="successfullEditCompetenceInside ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
              >
                {{ messageEditCompetenceInside }}
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="editCompetenceDialog = false"> Cancel </v-btn>
            <v-btn v-if="!editingCompetence" type="submit" class="ok-modal"> Update </v-btn>
            <v-btn v-else class="ok-modal" disabled>
              <v-progress-circular indeterminate color="primary" />
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteCompetenceDialog" max-width="500">
      <v-card>
        <v-card-title class="px-6">
          <h5 class="primary-color">Delete Competence</h5>
        </v-card-title>
        <v-card-text class="mt-4 pb-0 px-6">
          <p class="mb-0">
            Do you really want to delete the selected competence? <br />
            If so, press Confirm.
          </p>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn text class="cancel-modal" @click="deleteCompetenceDialog = false"> Cancel </v-btn>

          <template v-if="!deletingCompetence">
            <v-btn class="ok-modal" @click="deleteCompetence"> Confirm </v-btn>
          </template>
          <v-btn v-else class="ok-modal" disabled @click="deleteCompetence">
            <v-progress-circular indeterminate color="primary" />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDetailsCompetenceDialog" max-width="800">
      <v-card>
        <v-form ref="detailsCompetenceForm">
          <v-card-title class="px-6">
            <h5 class="primary-color">Details</h5>
          </v-card-title>
          <v-card-text class="mt-4 pb-0 px-6">
            <v-container>
              <v-row>
                <v-col cols="4">
                  <h6 class="details-subtitles primary-color">Name:</h6>
                </v-col>
                <v-col cols="8">
                  <p class="mb-0">{{ itemToShow.name }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <h6 class="details-subtitles primary-color">Legacy name:</h6>
                </v-col>
                <v-col cols="8">
                  <p class="mb-0">{{ itemToShow.legacyName }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <h6 class="details-subtitles primary-color">Description:</h6>
                </v-col>
                <v-col cols="8">
                  <p class="mb-0">{{ itemToShow.description }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <h6 class="details-subtitles primary-color">Has training:</h6>
                </v-col>
                <v-col cols="8">
                  <p v-if="itemToShow.hasTraining" class="mb-0">
                    <v-icon size="20" color="green">mdi-check</v-icon>
                  </p>
                  <p v-else class="mb-0">
                    <v-icon size="20" color="red">mdi-close</v-icon>
                  </p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <h6 class="details-subtitles primary-color">Extra weight:</h6>
                </v-col>
                <v-col cols="8">
                  <p class="mb-0">{{ itemToShow.extraWeight }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <h6 class="details-subtitles primary-color">Type:</h6>
                </v-col>
                <v-col cols="8">
                  <p class="mb-0">{{ itemToShow.type }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <h6 class="details-subtitles primary-color">Category:</h6>
                </v-col>
                <v-col cols="8">
                  <p class="mb-0">{{ itemToShow.category }}</p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="px-4 pb-4">
            <v-spacer />
            <v-btn text class="cancel-modal" @click="showDetailsCompetenceDialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CompetenciesDataService from '@/services/CompetenciesDataService';

export default {
  name: 'CompetenciesList',
  data() {
    return {
      competencies: [],
      successfullCompetencies: false,
      messageCompetencies: '',
      info: {},
      successfullInfo: false,
      messageInfo: '',
      loading: false,
      successfullCreateCompetence: false,
      messageCreateCompetence: '',
      successfullCreateCompetenceInside: false,
      messageCreateCompetenceInside: '',
      successfullEditCompetence: false,
      messageEditCompetence: '',
      successfullEditCompetenceInside: false,
      messageEditCompetenceInside: '',
      successfullDeleteCompetence: false,
      messageDeleteCompetence: '',
      headers: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Legacy name', value: 'legacyName', sortable: false },
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Category', value: 'category', sortable: false },
        { text: 'Has training', value: 'hasTraining', sortable: false },
        { text: 'Extra weight', value: 'extraWeight', sortable: false },
        { text: 'Created at', value: 'createdAt', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalPages: 1,
        totalItems: 0,
      },
      competence: {
        name: '',
        legacyName: '',
        description: '',
        hasTraining: false,
        extraWeight: '0',
        type: 'Competencia',
        category: 'Gestión Personal',
        status: 1,
      },
      rules: [(v) => !!v || 'Required field'],
      rulesNumber: [(v) => v !== '' || 'Required field'],
      createCompetenceDialog: false,
      creatingCompetence: false,
      editCompetenceDialog: false,
      editingCompetence: false,
      deleteCompetenceDialog: false,
      deletingCompetence: false,
      itemToEdit: {},
      itemToDelete: {},
      itemToShow: {},
      showDetailsCompetenceDialog: false,
    };
  },
  async mounted() {
    await this.getInfo();
    await this.getAllCompetencies(1);
  },
  methods: {
    getAllCompetencies(page) {
      this.loading = true;

      CompetenciesDataService.findAll(page, this.pagination.itemsPerPage).then(
        (response) => {
          if (response.status == 200) {
            this.competencies = response.data.data;

            if (this.competencies.length !== 0) {
              this.pagination.page = page;
              this.pagination.totalPages = response.data.links.totalPages || 1;

              this.pagination.totalItems =
                response.data.links.totalItems ||
                this.pagination.totalPages * this.pagination.itemsPerPage;
            }
          } else {
            this.successfullCompetencies = false;
            this.messageCompetencies =
              'An error has occurred retrieving the list of competencies. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullCompetencies = false;
          this.messageCompetencies =
            'An error has occurred retrieving the list of competencies. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    handlePageChange(newPage) {
      this.pagination.page = newPage;
      this.getAllCompetencies(newPage);
    },
    getInfo() {
      this.loading = true;

      CompetenciesDataService.getInfo().then(
        (response) => {
          if (response.status == 200) this.info = response.data.data;
          else {
            this.successfullInfo = false;
            this.messageInfo =
              'An error has occurred retrieving the competencies information. Please, try again later.';
          }

          this.loading = false;
        },
        (error) => {
          this.successfullInfo = false;
          this.messageInfo =
            'An error has occurred retrieving the competencies information. Please, try again later.';

          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          }

          this.loading = false;
        }
      );
    },
    openCreateCompetence() {
      this.createCompetenceDialog = true;
    },
    createCompetence() {
      this.successfullCreateCompetence = true;
      this.messageCreateCompetence = '';

      if (this.$refs.createCompetenceForm.validate()) {
        this.creatingCompetence = true;

        CompetenciesDataService.create(this.competence).then(
          (response) => {
            if (response.status == 201) {
              this.getAllCompetencies(1);

              this.messageCreateCompetence = '';
              this.successfullCreateCompetence = true;

              setTimeout(() => {
                this.messageCreateCompetence = 'Competence successfully created.';
              }, 10);
            } else {
              this.messageCreateCompetence = '';
              this.successfullCreateCompetence = true;

              setTimeout(() => {
                this.messageCreateCompetence =
                  'An error has occurred creating the competence. Please, try again later.';
              }, 10);
            }

            this.createCompetenceDialog = false;
            this.creatingCompetence = false;
            this.competence = {
              name: '',
              legacyName: '',
              description: '',
              hasTraining: false,
              extraWeight: '0',
              type: 'Competencia',
              category: 'Gestión Personal',
              status: 1,
            };
          },
          (error) => {
            this.messageCreateCompetenceInside = '';
            this.messageCreateCompetence = '';

            if (error.response.status === 409) {
              this.successfullCreateCompetenceInside = false;

              setTimeout(() => {
                this.messageCreateCompetenceInside =
                  'Competence already in use. Please, change its name.';
              }, 10);
            } else if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/');
            } else {
              this.successfullCreateCompetence = false;

              setTimeout(() => {
                this.messageCreateCompetence =
                  'An error has occurred creating the competence. Please, try again later.';
              }, 10);

              this.createCompetenceDialog = false;
              this.competence = {
                name: '',
                legacyName: '',
                description: '',
                hasTraining: false,
                extraWeight: '0',
                type: 'Competencia',
                category: 'Gestión Personal',
                status: 1,
              };
            }

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            this.creatingCompetence = false;
          }
        );
      }
    },
    cancelCreateCompetence() {
      this.createCompetenceDialog = false;
      this.competence = {
        name: '',
        legacyName: '',
        description: '',
        hasTraining: false,
        extraWeight: '0',
        type: 'Competencia',
        category: 'Gestión Personal',
        status: 1,
      };
    },
    openEditCompetence(competence) {
      this.itemToEdit = { ...competence };
      this.editCompetenceDialog = true;
    },
    editCompetence() {
      this.successfullEditCompetence = true;

      if (this.$refs.editCompetenceForm.validate()) {
        this.editingCompetence = true;

        CompetenciesDataService.update(this.itemToEdit).then(
          (response) => {
            if (response.status == 204) {
              this.getAllCompetencies(1);
              this.messageEditCompetence = '';
              this.successfullEditCompetence = true;

              setTimeout(() => {
                this.messageEditCompetence = 'Competence successfully updated.';
              }, 10);
            } else {
              this.messageEditCompetence = '';
              this.successfullEditCompetence = true;

              setTimeout(() => {
                this.messageEditCompetence =
                  'An error has occurred updating the competence. Please, try again later.';
              }, 10);
            }

            this.editCompetenceDialog = false;
            this.editingCompetence = false;
            this.itemToEdit = {};
          },
          (error) => {
            this.messageEditCompetenceInside = '';
            this.messageEditCompetence = '';

            if (error.response.status === 409) {
              this.successfullEditCompetenceInside = false;

              setTimeout(() => {
                this.messageEditCompetenceInside =
                  'Competence already in use. Please, change its name.';
              }, 10);
            } else if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/');
            } else {
              this.successfullEditCompetence = false;

              setTimeout(() => {
                this.messageEditCompetence =
                  'An error has occurred updating the competence. Please, try again later.';
              }, 10);

              this.editCompetenceDialog = false;
              this.itemToEdit = {};
            }

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            this.editingCompetence = false;
          }
        );
      }
    },
    openDeleteCompetence(competence) {
      this.itemToDelete = { ...competence };
      this.deleteCompetenceDialog = true;
    },
    deleteCompetence() {
      if (this.itemToDelete.id !== undefined) {
        this.deletingCompetence = true;

        CompetenciesDataService.delete(this.itemToDelete.id).then(
          (response) => {
            if (response.status == 204) {
              this.getAllCompetencies(1);
              this.messageDeleteCompetence = '';
              this.successfullDeleteCompetence = true;

              setTimeout(() => {
                this.messageDeleteCompetence = 'Competence successfully deleted.';
              }, 10);
            } else {
              this.messageDeleteCompetence = '';
              this.successfullDeleteCompetence = false;

              setTimeout(() => {
                this.messageDeleteCompetence =
                  'An error has occurred deleting the competence. Please, try again later.';
              }, 10);
            }

            this.deleteCompetenceDialog = false;
            this.deletingCompetence = false;
            this.itemToDelete = {};
          },
          (error) => {
            this.messageDeleteCompetence = '';
            this.successfullDeleteCompetence = false;

            setTimeout(() => {
              this.messageDeleteCompetence =
                'An error has occurred deleting the competence. Please, try again later.';
            }, 10);

            this.deleteCompetenceDialog = false;
            this.itemToDelete = {};

            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            if (error.response.status === 401 || error.response.status === 403) {
              localStorage.removeItem('user');
              this.$router.push('/');
            }

            this.deletingCompetence = false;
          }
        );
      } else {
        this.messageDeleteCompetence = '';
        this.successfullDeleteCompetence = false;

        setTimeout(() => {
          this.messageDeleteCompetence =
            'An error has occurred deleting the competence. Please, try again later.';
        }, 10);

        this.deleteCompetenceDialog = false;
        this.itemToDelete = {};
      }
    },
    openShowDetails(competence) {
      this.itemToShow = { ...competence };
      this.showDetailsCompetenceDialog = true;
    },
  },
};
</script>
